export const GetOrganizationPrimaryColorHex = (organizationId) => {

    switch (organizationId){
        case 1: return "#ea580c"; // Kinesis (Internal)
        case 2: return "#f5852a"; // Kinesis Integrated
        case 3: return "#525252"; // JHHS
        case 4: return "#338ec6"; // GRC
        case 5: return "#864799"; // Integrated Stride Coaching
        case 6: return "#1ab7ea"; // Madison Multi Sport
        case 7: return "#e22b31"; // D3 Multi Sport
        case 8: return "#ffdd65"; // Lions Den Fitness
        case 9: return "#341fb6"; // Miles To Go
        default: return "#ea580c"
    }

}